/**
 * Resolves the payment entries from a receipt object.
 * Handles: multiplePayment array, PaymentType JSON string, plain string.
 */
export function resolvePaymentEntries(raw: any): { name: string; amount: number }[] {
  const mp = raw?.multiplePayment
  if (Array.isArray(mp) && mp.length > 0) {
    return mp.map((p: any) => ({ name: String(p.name ?? ''), amount: Number(p.amount ?? 0) }))
  }

  const pt = raw?.PaymentType ?? raw?.paymentType
  if (!pt) return []

  if (typeof pt === 'string' && pt.trimStart().startsWith('[')) {
    try {
      const parsed = JSON.parse(pt)
      if (Array.isArray(parsed)) {
        return parsed.map((p: any) => ({ name: String(p.name ?? ''), amount: Number(p.amount ?? 0) }))
      }
    } catch {}
  }

  return [{ name: String(pt), amount: 0 }]
}

/**
 * Returns a display string like "Cash : 340, MASTER CARD : 1,000"
 * Amount is omitted when it is 0 (plain string payment types).
 */
export function formatPaymentType(raw: any): string {
  const entries = resolvePaymentEntries(raw)
  if (!entries.length) return '-'
  return entries
    .map(e =>
      e.amount > 0
        ? `${e.name} : ${Number(e.amount).toLocaleString('en-US')}`
        : e.name,
    )
    .join(', ')
}

/**
 * Returns an array of payment type names only — used for filtering/grouping.
 */
export function parsePaymentNames(raw: any): string[] {
  const entries = resolvePaymentEntries(raw)
  return entries.map(e => e.name).filter(Boolean)
}
